import { User } from '@tendercuts/models';
import { Injectable } from '@angular/core';
import { AuthProtocol } from '@tendercuts/http/auth';
import { BasePostProvider, DataTransformationProtocol } from '@tendercuts/http';
import { EndPoint } from '../base';
import { PubSubService } from '../pubsub';
import { StorageService } from '../storage';
import { Store as AppStore } from '@ngrx/store';
import * as fromStore from '@store/state';
import { AppState } from '@store/state';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoginServices extends BasePostProvider<User>
  implements AuthProtocol, DataTransformationProtocol {
  KEY = 'user22';

  // public user: User;

  constructor(
    public http: HttpClient,
    public events: PubSubService,
    public storage: StorageService,
    public endpointService: EndPoint,
    public store: AppStore<AppState>
  ) {
    super(http);
  }

  getToken() {
    return this.store.select(fromStore.getUser);
  }

  get model() {
    return User;
  }

  get isAuthenticatedEndpoint() {
    return false;
  }

  get authProtocol() {
    return null;
  }

  get endpoint() {
    return this.endpointService.login;
  }

  postProcessResponse(data) {
    return this.data[0];
  }


  get user() {
    var user;
    var clbk = function(state) {
      user = state.user;
    };

    this.store.select(state => state.userState).subscribe(clbk);
    return user;
  }
}
